import React from 'react';
import Button from "../../../components/ui/button/button";
import {withRouter} from "../../../layouts/AdminLayout/AdminLayout";
import API from "../../../components/api";
import {ReactComponent as OrderLeftIcon} from "../../../images/icons/ui/order-left.svg";
import {ReactComponent as PlusIcon} from "../../../images/icons/ui/plus-icon.svg";
import {ReactComponent as EditIcon} from "../../../images/icons/ui/edit-icon.svg";
import {ReactComponent as OrderUpIcon} from "../../../images/icons/ui/order-up.svg";
import {ReactComponent as OrderDownIcon} from "../../../images/icons/ui/order-down.svg";
import {ReactComponent as TrashIcon} from "../../../images/icons/ui/trash-icon.svg";
import ModalComponent from "../../../components/ui/modalComponent/modalComponent";
import TextField from "../../../components/TextField/TextField";
import Checkbox from "../../../components/ui/checkbox/checkbox";
import RadioSlider from "../../../components/ui/radioSlider/radioSlider";


class AdminPanelServicesCategorySubcategoryPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            category: {
                name: 'Услуги'
            },
            subcategory: {
                name: 'Загрузка...'
            },
            subcategories: [],
            services: [],

            currentCategory: {},

            isCategoryCreateOpen: false,
            isCategoryEditOpen: false,
            isCategoryDeleteOpen: false,

            categoryNameCreated: '',
            categoryNameEdited: '',

            tabValues: [
                {name: 'Фикс', value: 'fix'},
                {name: 'От-До', value: 'from-to',},
                {name: 'Только От', value: 'only-from',},
                {name: 'Бесплатно', value: 'free'},
            ],
            tabValue: 'from-to',
        }

        this.swapCategory = (categoryId, side) => {
            const {subcategories} = this.state;
            let categories = subcategories

            const index = categories.findIndex(c => c.id === categoryId);
            if (index === -1) return;

            const targetIndex =
                side === 'up'
                    ? index - 1
                    : side === 'down'
                        ? index + 1
                        : index;

            if (targetIndex < 0 || targetIndex >= categories.length) {
                return;
            }

            const current = categories[index];
            const target = categories[targetIndex];

            if (current.order == null || target.order == null) {
                return;
            }

            categories[index] = target;
            categories[targetIndex] = current;

            this.setState({subcategories: categories})
        }

        this.swapService = (serviceId, side) => {
            const {services} = this.state;

            const index = services.findIndex(c => c.id === serviceId);
            if (index === -1) return;

            const targetIndex =
                side === 'up'
                    ? index - 1
                    : side === 'down'
                        ? index + 1
                        : index;

            if (targetIndex < 0 || targetIndex >= services.length) {
                return;
            }

            const current = services[index];
            services[index] = services[targetIndex];
            services[targetIndex] = current;

            this.setState({services: services})
        }

        this.deleteService = (serviceId) => {
            this.setState(prevState => {
                const services = prevState.services;
                const newServices = services.filter(s => s.id !== serviceId);

                return {
                    services: newServices
                };
            });
        };

        this.updateCategories = () => {
            API.adminGetSubCategories(this.state.categoryId)
                .then(data => this.setState({subcategories: data}))
                .catch(error => {
                })
        }

        this.addCategory = (name) => {
            API.adminCreateSubCategory(this.state.categoryId, name)
                .then(data => {
                    this.props.addSnackbar("Категория успешно создана", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateCategories()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось добавить категорию", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.editCategory = (subcategoryId, name) => {
            API.adminEditSubCategory(subcategoryId, name)
                .then(data => {
                    this.props.addSnackbar("Категория успешно изменена", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateCategories()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось изменить категорию", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.deleteCategory = (subcategoryId) => {
            API.adminDeleteSubCategory(subcategoryId)
                .then(data => {
                    this.props.addSnackbar("Категория успешно удалена", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateCategories()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось удалить категорию", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.saveCategories = (categories) => {
            let newOrders = []

            categories.forEach((category, index) => {
                newOrders.push(category.id)
            })

            API.adminSaveSubCategoriesOrder(newOrders)
                .then(data => {
                    this.props.addSnackbar("Порядок подкатегорий сохранен", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateCategories()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось сохранить", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.saveServices = (services) => {
            API.adminSaveSubcategoryServices(this.state.categoryId, this.state.subcategoryId, services)
                .then(data => {
                    this.props.addSnackbar("Услуги подкатегории успешно сохранены", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateServices()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось сохранить услуги", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.savePage = () => {
            this.saveServices(this.state.services)
        }

        this.updateServices = () => {
            API.adminGetCategorySubcategoryServices(this.state.categoryId, this.state.subcategoryId)
                .then(data => this.setState({services: data}))
                .catch(error => {
                })
        }

        this.addService = () => {
            const {services} = this.state;

            let service = {
                id: -Math.random(),
                name: '',
                description: '',
                order: 0,
                price_from: 3500,
                price_to: 3500,
                price_type: 'from-to',
                show_on_home: 0,
            }

            this.setState({
                services: [service, ...services]
            });
        }

        this.changeService = (name, index, value) => {
            let {services} = this.state;

            services[index][value] = name

            this.setState({
                services: [...services]
            });
        }
    }

    componentDidMount() {
        API.adminFullSubCategoryLoad(this.props.params.categoryId, this.props.params.subcategoryId)
            .then(data => {
                this.setState({
                    category: data.category,
                    subcategory: data.subcategory,
                })
            })
        this.setState({
            categoryId: this.props.params.categoryId,
            subcategoryId: this.props.params.subcategoryId
        }, () => {
            this.updateCategories()
            this.updateServices()
        })
    }

    render() {
        return <div className='admin-page-container'>
            <div className='header'>
                <Button customClass='icon-size-24' type='transparent' size='medium' fullWidth
                        startIcon={<OrderLeftIcon/>}
                        onClick={() => this.props.navigate(`/admin/panel/services/${this.props.params.categoryId}/`)}/>
                <div className='content'>
                    <div className='sub-title'>
                        {this.state.category.name}
                    </div>
                    <div className='title'>
                        {this.state.subcategory.name}
                    </div>
                </div>
                <div className='controls'>
                    <Button type='accent' size='medium' onClick={() => {
                        this.savePage()
                    }}>
                        Сохранить изменения
                    </Button>
                    <Button type='primary' size='medium'
                            onClick={() => this.updateCategories()}>
                        Отменить
                    </Button>
                </div>
            </div>
            <div className='content'>
                <div className='title'>
                    Услуги
                </div>
                <Button type='transparent' size='large' fullWidth
                        startIcon={<PlusIcon/>}
                        onClick={() => this.addService()}>
                    Добавить услугу
                </Button>
                <div className='services'>
                    {
                        this.state.services.map((service, index) => {
                            const priceType = service.price_type;

                            return <div key={service.id} className='service'>
                                <div className='top'>
                                    <TextField label='Название услуги' fullWidth multiline
                                               value={this.state.services[index].name}
                                               onChange={(e) => this.changeService(e.target.value, index, 'name')}/>
                                    <div className='button-group'>
                                        <div className='buttons'>
                                            <div className='divider'/>
                                            <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                                    startIcon={<OrderUpIcon/>}
                                                    onClick={() => this.swapService(service.id, 'up')}/>
                                            <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                                    startIcon={<OrderDownIcon/>}
                                                    onClick={() => this.swapService(service.id, 'down')}/>
                                            <div className='divider'/>
                                            <Button type='primary' size='medium' fullWidth
                                                    startIcon={<TrashIcon/>}
                                                    onClick={() => this.deleteService(service.id)}/>
                                        </div>
                                        <div className='field' onClick={(e) => {
                                            this.changeService(!this.state.services[index].show_on_home, index, 'show_on_home')
                                        }}>
                                            <Checkbox
                                                checked={this.state.services[index].show_on_home}
                                            />
                                            <div className='label'>
                                                На главной
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='bottom'>
                                    <RadioSlider value={priceType}
                                                 buttons={this.state.tabValues}
                                                 setValue={(value) => this.changeService(value, index, 'price_type')}/>
                                    {['fix', 'from-to', 'only-from'].includes(priceType) && (
                                        <TextField
                                            label={priceType === 'fix' ? 'Цена, ₽' : 'Цена от, ₽'}
                                            fullWidth
                                            type="number"
                                            value={service.price_from}
                                            onChange={(e) =>
                                                this.changeService(e.target.value, index, 'price_from')
                                            }
                                        />
                                    )}

                                    {/* Цена до */}
                                    {priceType === 'from-to' && (
                                        <TextField
                                            label="Цена до, ₽"
                                            fullWidth
                                            type="number"
                                            value={service.price_to}
                                            onChange={(e) =>
                                                this.changeService(e.target.value, index, 'price_to')
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    }
}


export default withRouter(AdminPanelServicesCategorySubcategoryPage);
